webpackJsonp([154199477766010],{

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _Fade = _interopRequireDefault(__webpack_require__(45));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    // Disable scroll capabilities.
	    touchAction: 'none'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	
	function Backdrop(props) {
	  var classes = props.classes,
	      className = props.className,
	      invisible = props.invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), _react.default.createElement("div", {
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
	    "aria-hidden": "true"
	  }));
	}
	
	Backdrop.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Backdrop.defaultProps = {
	  invisible: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(71));

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _helpers = __webpack_require__(21);
	
	var _Modal = _interopRequireDefault(__webpack_require__(76));
	
	var _Fade = _interopRequireDefault(__webpack_require__(45));
	
	var _transitions = __webpack_require__(31);
	
	var _Paper = _interopRequireDefault(__webpack_require__(53));
	
	// @inheritedComponent Modal
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `scroll="paper"`. */
	    scrollPaper: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `scroll="body"`. */
	    scrollBody: {
	      overflowY: 'auto',
	      overflowX: 'hidden'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      display: 'flex',
	      flexDirection: 'column',
	      margin: 48,
	      position: 'relative',
	      overflowY: 'auto',
	      // Fix IE 11 issue, to remove at some point.
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 'none'
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="paper"`. */
	    paperScrollPaper: {
	      flex: '0 1 auto',
	      maxHeight: 'calc(100% - 96px)'
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="body"`. */
	    paperScrollBody: {
	      margin: '48px auto'
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 360),
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 360) + 48 * 2), {
	        margin: 48
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 48 * 2), {
	        margin: 48
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 48 * 2), {
	        margin: 48
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
	    paperWidthLg: {
	      maxWidth: theme.breakpoints.values.lg,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 48 * 2), {
	        margin: 48
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
	    paperFullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
	    paperFullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: 'none',
	      borderRadius: 0,
	      '&$paperScrollBody': {
	        margin: 0
	      }
	    }
	  };
	};
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	
	
	exports.styles = styles;
	
	function Dialog(props) {
	  var _classNames;
	
	  var BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      disableBackdropClick = props.disableBackdropClick,
	      disableEscapeKeyDown = props.disableEscapeKeyDown,
	      fullScreen = props.fullScreen,
	      fullWidth = props.fullWidth,
	      maxWidth = props.maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      PaperProps = props.PaperProps,
	      scroll = props.scroll,
	      TransitionComponent = props.TransitionComponent,
	      transitionDuration = props.transitionDuration,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classes["scroll".concat((0, _helpers.capitalize)(scroll))], className),
	    BackdropProps: (0, _extends2.default)({
	      transitionDuration: transitionDuration
	    }, BackdropProps),
	    disableBackdropClick: disableBackdropClick,
	    disableEscapeKeyDown: disableEscapeKeyDown,
	    onBackdropClick: onBackdropClick,
	    onEscapeKeyDown: onEscapeKeyDown,
	    onClose: onClose,
	    open: open,
	    role: "dialog"
	  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    timeout: transitionDuration,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited
	  }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: 24,
	    className: (0, _classnames.default)(classes.paper, classes["paperScroll".concat((0, _helpers.capitalize)(scroll))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames))
	  }, PaperProps), children)));
	}
	
	Dialog.propTypes =  false ? {
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog will be full-screen
	   */
	  fullScreen: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog stretches to `maxWidth`.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determine the max width of the dialog.
	   * The dialog width grows with the size of the screen, this property is useful
	   * on the desktop where you might need some coherent different width size across your
	   * application. Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', false]),
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Properties applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Determine the container for scrolling the dialog.
	   */
	  scroll: _propTypes.default.oneOf(['body', 'paper']),
	
	  /**
	   * Transition component.
	   */
	  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Properties applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : {};
	Dialog.defaultProps = {
	  disableBackdropClick: false,
	  disableEscapeKeyDown: false,
	  fullScreen: false,
	  fullWidth: false,
	  maxWidth: 'sm',
	  scroll: 'paper',
	  TransitionComponent: _Fade.default,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialog'
	})(Dialog);
	
	exports.default = _default;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	
	var _Dialog = _interopRequireDefault(__webpack_require__(115));

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    flex: '1 1 auto',
	    overflowY: 'auto',
	    WebkitOverflowScrolling: 'touch',
	    // Add iOS momentum scrolling.
	    padding: '0 24px 24px',
	    '&:first-child': {
	      paddingTop: 24
	    }
	  }
	};
	exports.styles = styles;
	
	function DialogContent(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), children);
	}
	
	DialogContent.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContent'
	})(DialogContent);
	
	exports.default = _default;

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(117));

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _Typography = _interopRequireDefault(__webpack_require__(134));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    margin: 0,
	    padding: '24px 24px 20px',
	    flex: '0 0 auto'
	  }
	};
	exports.styles = styles;
	
	function DialogTitle(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      disableTypography = props.disableTypography,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
	    variant: "title",
	    internalDeprecatedVariant: true
	  }, children));
	}
	
	DialogTitle.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes.default.bool
	} : {};
	DialogTitle.defaultProps = {
	  disableTypography: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogTitle'
	})(DialogTitle);
	
	exports.default = _default;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(119));

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = _interopRequireDefault(__webpack_require__(52));
	
	var _transitions = __webpack_require__(31);
	
	var _withTheme = _interopRequireDefault(__webpack_require__(29));
	
	var _utils = __webpack_require__(34);
	
	// @inheritedComponent Transition
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	/**
	 * The Fade transition is used by the [Modal](/utils/modal/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Fade, _React$Component);
	
	  function Fade() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Fade);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _this.handleEnter = function (node) {
	      var theme = _this.props.theme;
	      (0, _utils.reflow)(node); // So the animation always start from the start.
	
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      });
	      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	      node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    };
	
	    _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      });
	      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	      node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Fade, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          onEnter = _this$props.onEnter,
	          onExit = _this$props.onExit,
	          styleProp = _this$props.style,
	          theme = _this$props.theme,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
	      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        appear: true,
	        onEnter: this.handleEnter,
	        onExit: this.handleExit
	      }, other), function (state, childProps) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          style: (0, _extends2.default)({
	            opacity: 0,
	            willChange: 'opacity'
	          }, styles[state], style)
	        }, childProps));
	      });
	    }
	  }]);
	  return Fade;
	}(_react.default.Component);
	
	Fade.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Fade.defaultProps = {
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()(Fade);
	
	exports.default = _default;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(73));

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(63);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _helpers = __webpack_require__(21);
	
	var _reactHelpers = __webpack_require__(24);
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    position: 'relative',
	    // Reset fieldset default style.
	    minWidth: 0,
	    padding: 0,
	    margin: 0,
	    border: 0,
	    verticalAlign: 'top',
	    // Fix alignment issue on Safari.
	    zIndex: 0 // Reset the stacking context for the label z-index.
	
	  },
	
	  /* Styles applied to the root element if `margin="normal"`. */
	  marginNormal: {
	    marginTop: 16,
	    marginBottom: 8
	  },
	
	  /* Styles applied to the root element if `margin="dense"`. */
	  marginDense: {
	    marginTop: 8,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the root element if `fullWidth={true}`. */
	  fullWidth: {
	    width: '100%'
	  }
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibilty and ensures that the state always stays
	 * consistent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 *
	 * ⚠️ Only one input can be used within a FormControl.
	 */
	
	exports.styles = styles;
	
	var FormControl =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(FormControl, _React$Component);
	
	  function FormControl(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, FormControl);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormControl).call(this));
	
	    _this.handleFocus = function () {
	      _this.setState(function (state) {
	        return !state.focused ? {
	          focused: true
	        } : null;
	      });
	    };
	
	    _this.handleBlur = function () {
	      _this.setState(function (state) {
	        return state.focused ? {
	          focused: false
	        } : null;
	      });
	    };
	
	    _this.handleDirty = function () {
	      if (!_this.state.filled) {
	        _this.setState({
	          filled: true
	        });
	      }
	    };
	
	    _this.handleClean = function () {
	      if (_this.state.filled) {
	        _this.setState({
	          filled: false
	        });
	      }
	    };
	
	    _this.state = {
	      adornedStart: false,
	      filled: false,
	      focused: false
	    }; // We need to iterate through the children and find the Input in order
	    // to fully support server side rendering.
	
	    var children = props.children;
	
	    if (children) {
	      _react.default.Children.forEach(children, function (child) {
	        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _utils.isFilled)(child.props, true)) {
	          _this.state.filled = true;
	        }
	
	        var input = (0, _reactHelpers.isMuiElement)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _utils.isAdornedStart)(input.props)) {
	          _this.state.adornedStart = true;
	        }
	      });
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(FormControl, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _this$props = this.props,
	          disabled = _this$props.disabled,
	          error = _this$props.error,
	          required = _this$props.required,
	          margin = _this$props.margin,
	          variant = _this$props.variant;
	      var _this$state = this.state,
	          adornedStart = _this$state.adornedStart,
	          filled = _this$state.filled,
	          focused = _this$state.focused;
	      return {
	        muiFormControl: {
	          adornedStart: adornedStart,
	          disabled: disabled,
	          error: error,
	          filled: filled,
	          focused: focused,
	          margin: margin,
	          onBlur: this.handleBlur,
	          onEmpty: this.handleClean,
	          onFilled: this.handleDirty,
	          onFocus: this.handleFocus,
	          required: required,
	          variant: variant
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props2 = this.props,
	          classes = _this$props2.classes,
	          className = _this$props2.className,
	          Component = _this$props2.component,
	          disabled = _this$props2.disabled,
	          error = _this$props2.error,
	          fullWidth = _this$props2.fullWidth,
	          margin = _this$props2.margin,
	          required = _this$props2.required,
	          variant = _this$props2.variant,
	          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required", "variant"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
	      }, other));
	    }
	  }]);
	  return FormControl;
	}(_react.default.Component);
	
	FormControl.propTypes =  false ? {
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : {};
	FormControl.defaultProps = {
	  component: 'div',
	  disabled: false,
	  error: false,
	  fullWidth: false,
	  margin: 'none',
	  required: false,
	  variant: 'standard'
	};
	FormControl.childContextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(121));

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _InputBase = __webpack_require__(37);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Styles applied to the root element if `required={true}`. */
	    required: {},
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function FormLabel(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      required = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "required"]);
	  var fcs = (0, _InputBase.formControlState)({
	    props: props,
	    context: context,
	    states: ['required', 'focused', 'disabled', 'error', 'filled']
	  });
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.filled), (0, _defineProperty2.default)(_classNames, classes.focused, fcs.focused), (0, _defineProperty2.default)(_classNames, classes.required, fcs.required), _classNames), classNameProp)
	  }, other), children, fcs.required && _react.default.createElement("span", {
	    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, fcs.error))
	  }, "\u2009*"));
	}
	
	FormLabel.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : {};
	FormLabel.defaultProps = {
	  component: 'label'
	};
	FormLabel.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(123));

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _helpers = __webpack_require__(21);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      fontSize: 24,
	      width: '1em',
	      height: '1em',
	      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
	      // To remove at some point.
	      overflow: 'hidden',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: 20
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: 36
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Icon(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      Component = props.component,
	      fontSize = props.fontSize,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)('material-icons', classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
	    "aria-hidden": "true"
	  }, other), children);
	}
	
	Icon.propTypes =  false ? {
	  /**
	   * The name of the icon font ligature.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
	} : {};
	Icon.defaultProps = {
	  color: 'inherit',
	  component: 'span',
	  fontSize: 'default'
	};
	Icon.muiName = 'Icon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIcon'
	})(Icon);
	
	exports.default = _default;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	
	var _Icon = _interopRequireDefault(__webpack_require__(125));

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _InputBase = _interopRequireDefault(__webpack_require__(130));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	// @inheritedComponent InputBase
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      'label + &': {
	        marginTop: 16
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:not($disabled):not($focused):not($error):before': {
	        borderBottom: "2px solid ".concat(theme.palette.text.primary)
	      },
	      '&$disabled:before': {
	        borderBottom: "1px dotted ".concat(bottomLineColor)
	      }
	    },
	
	    /* Styles applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {},
	
	    /* Styles applied to the `input` element. */
	    input: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {},
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {},
	
	    /* Styles applied to the `input` element if `type` is not "text"`. */
	    inputType: {},
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {}
	  };
	};
	
	exports.styles = styles;
	
	function Input(props) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes"]);
	  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.underline, !disableUnderline)),
	      underline: null
	    })
	  }, other));
	}
	
	Input.propTypes =  false ? {
	  /**
	   * This property helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it here:
	   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the input will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the wrapper element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default input value, useful when not controlling the component.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the native input.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Attributes applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value`.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the input element. It should be a valid HTML5 input type.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The input value, required for a controlled component.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
	} : {};
	_InputBase.default.defaultProps = {
	  fullWidth: false,
	  inputComponent: 'input',
	  multiline: false,
	  type: 'text'
	};
	Input.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInput'
	})(Input);
	
	exports.default = _default;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(127));

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formControlState = formControlState;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _reactHelpers = __webpack_require__(24);
	
	var _Textarea = _interopRequireDefault(__webpack_require__(129));
	
	var _utils = __webpack_require__(63);
	
	/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter
	    })
	  };
	  var placeholderHidden = {
	    opacity: 0
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      // Mimics the default input display property used by browsers for an input.
	      fontFamily: theme.typography.fontFamily,
	      color: theme.palette.text.primary,
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '1.1875em',
	      // Reset (19px), match the native input line-height
	      cursor: 'text',
	      display: 'inline-flex',
	      alignItems: 'center',
	      '&$disabled': {
	        color: theme.palette.text.disabled,
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {},
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {},
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {},
	
	    /* Styles applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px")
	    },
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      font: 'inherit',
	      color: 'currentColor',
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      border: 0,
	      boxSizing: 'content-box',
	      background: 'none',
	      margin: 0,
	      // Reset for Safari
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      // Fix IE 11 width issue
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder,
	      // Firefox 19+
	      '&:-ms-input-placeholder': placeholder,
	      // IE 11
	      '&::-ms-input-placeholder': placeholder,
	      // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden,
	        // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden,
	        // IE 11
	        '&::-ms-input-placeholder': placeholderHidden,
	        // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible,
	        // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible,
	        // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	
	      },
	      '&$disabled': {
	        opacity: 1 // Reset iOS opacity
	
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 4 - 1
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      resize: 'none',
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `type` is not "text"`. */
	    inputType: {
	      // type="date" or type="time", etc. have specific styles we need to reset.
	      height: '1.1875em' // Reset (19px), match the native input line-height
	
	    },
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {},
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {}
	  };
	};
	
	exports.styles = styles;
	
	function formControlState(_ref) {
	  var props = _ref.props,
	      states = _ref.states,
	      context = _ref.context;
	  return states.reduce(function (acc, state) {
	    acc[state] = props[state];
	
	    if (context && context.muiFormControl) {
	      if (typeof props[state] === 'undefined') {
	        acc[state] = context.muiFormControl[state];
	      }
	    }
	
	    return acc;
	  }, {});
	}
	/**
	 * `InputBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating an input.
	 * It contains a load of style reset and some state logic.
	 */
	
	
	var InputBase =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(InputBase, _React$Component);
	
	  function InputBase(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, InputBase);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InputBase).call(this, props, context));
	    _this.state = {
	      focused: false
	    };
	
	    _this.handleFocus = function (event) {
	      // Fix a bug with IE 11 where the focus/blur events are triggered
	      // while the input is disabled.
	      if (formControlState({
	        props: _this.props,
	        context: _this.context,
	        states: ['disabled']
	      }).disabled) {
	        event.stopPropagation();
	        return;
	      }
	
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      var muiFormControl = _this.context.muiFormControl;
	
	      if (muiFormControl && muiFormControl.onFocus) {
	        muiFormControl.onFocus(event);
	      }
	    };
	
	    _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      var muiFormControl = _this.context.muiFormControl;
	
	      if (muiFormControl && muiFormControl.onBlur) {
	        muiFormControl.onBlur(event);
	      }
	    };
	
	    _this.handleChange = function () {
	      if (!_this.isControlled) {
	        _this.checkDirty(_this.inputRef);
	      } // Perform in the willUpdate
	
	
	      if (_this.props.onChange) {
	        var _this$props;
	
	        (_this$props = _this.props).onChange.apply(_this$props, arguments);
	      }
	    };
	
	    _this.handleRefInput = function (ref) {
	      _this.inputRef = ref;
	      var refProp;
	
	      if (_this.props.inputRef) {
	        refProp = _this.props.inputRef;
	      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
	        refProp = _this.props.inputProps.ref;
	      }
	
	      (0, _reactHelpers.setRef)(refProp, ref);
	    };
	
	    _this.handleClick = function (event) {
	      if (_this.inputRef && event.currentTarget === event.target) {
	        _this.inputRef.focus();
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    };
	
	    _this.isControlled = props.value != null;
	
	    if (_this.isControlled) {
	      _this.checkDirty(props);
	    }
	
	    var componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	      // The blur won't fire when the disabled state is set on a focused input.
	      // We need to book keep the focused state manually.
	      if (!formControlState({
	        props: _this.props,
	        context: _this.context,
	        states: ['disabled']
	      }).disabled && formControlState({
	        props: nextProps,
	        context: nextContext,
	        states: ['disabled']
	      }).disabled) {
	        _this.setState({
	          focused: false
	        });
	      }
	    };
	
	    var componentWillUpdate = function componentWillUpdate(nextProps, nextState, nextContext) {
	      // Book keep the focused state.
	      if (!formControlState({
	        props: _this.props,
	        context: _this.context,
	        states: ['disabled']
	      }).disabled && formControlState({
	        props: nextProps,
	        context: nextContext,
	        states: ['disabled']
	      }).disabled) {
	        var muiFormControl = _this.context.muiFormControl;
	
	        if (muiFormControl && muiFormControl.onBlur) {
	          muiFormControl.onBlur();
	        }
	      }
	    };
	    /* eslint-disable no-underscore-dangle */
	
	
	    _this.componentWillReceiveProps = componentWillReceiveProps;
	    _this.componentWillReceiveProps.__suppressDeprecationWarning = true;
	    _this.componentWillUpdate = componentWillUpdate;
	    _this.componentWillUpdate.__suppressDeprecationWarning = true;
	    /* eslint-enable no-underscore-dangle */
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(InputBase, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      // We are consuming the parent muiFormControl context.
	      // We don't want a child to consume it a second time.
	      return {
	        muiFormControl: null
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.isControlled) {
	        this.checkDirty(this.inputRef);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.isControlled) {
	        this.checkDirty(this.props);
	      } // else performed in the onChange
	
	    }
	  }, {
	    key: "checkDirty",
	    value: function checkDirty(obj) {
	      var muiFormControl = this.context.muiFormControl;
	
	      if ((0, _utils.isFilled)(obj)) {
	        if (muiFormControl && muiFormControl.onFilled) {
	          muiFormControl.onFilled();
	        }
	
	        if (this.props.onFilled) {
	          this.props.onFilled();
	        }
	
	        return;
	      }
	
	      if (muiFormControl && muiFormControl.onEmpty) {
	        muiFormControl.onEmpty();
	      }
	
	      if (this.props.onEmpty) {
	        this.props.onEmpty();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props2 = this.props,
	          autoComplete = _this$props2.autoComplete,
	          autoFocus = _this$props2.autoFocus,
	          classes = _this$props2.classes,
	          classNameProp = _this$props2.className,
	          defaultValue = _this$props2.defaultValue,
	          disabled = _this$props2.disabled,
	          endAdornment = _this$props2.endAdornment,
	          error = _this$props2.error,
	          fullWidth = _this$props2.fullWidth,
	          id = _this$props2.id,
	          inputComponent = _this$props2.inputComponent,
	          _this$props2$inputPro = _this$props2.inputProps;
	      _this$props2$inputPro = _this$props2$inputPro === void 0 ? {} : _this$props2$inputPro;
	      var inputPropsClassName = _this$props2$inputPro.className,
	          inputPropsProp = (0, _objectWithoutProperties2.default)(_this$props2$inputPro, ["className"]),
	          inputRef = _this$props2.inputRef,
	          margin = _this$props2.margin,
	          multiline = _this$props2.multiline,
	          name = _this$props2.name,
	          onBlur = _this$props2.onBlur,
	          onChange = _this$props2.onChange,
	          onClick = _this$props2.onClick,
	          onEmpty = _this$props2.onEmpty,
	          onFilled = _this$props2.onFilled,
	          onFocus = _this$props2.onFocus,
	          onKeyDown = _this$props2.onKeyDown,
	          onKeyUp = _this$props2.onKeyUp,
	          placeholder = _this$props2.placeholder,
	          readOnly = _this$props2.readOnly,
	          renderPrefix = _this$props2.renderPrefix,
	          rows = _this$props2.rows,
	          rowsMax = _this$props2.rowsMax,
	          startAdornment = _this$props2.startAdornment,
	          type = _this$props2.type,
	          value = _this$props2.value,
	          other = (0, _objectWithoutProperties2.default)(_this$props2, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onEmpty", "onFilled", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderPrefix", "rows", "rowsMax", "startAdornment", "type", "value"]);
	      var muiFormControl = this.context.muiFormControl;
	      var fcs = formControlState({
	        props: this.props,
	        context: this.context,
	        states: ['disabled', 'error', 'margin', 'required', 'filled']
	      });
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.multiline, multiline), (0, _defineProperty2.default)(_classNames, classes.adornedStart, startAdornment), (0, _defineProperty2.default)(_classNames, classes.adornedEnd, endAdornment), _classNames), classNameProp);
	      var inputClassName = (0, _classnames.default)(classes.input, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty2.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty2.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty2.default)(_classNames2, classes.inputMarginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedStart, startAdornment), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedEnd, endAdornment), _classNames2), inputPropsClassName);
	      var InputComponent = inputComponent;
	      var inputProps = (0, _extends2.default)({}, inputPropsProp, {
	        ref: this.handleRefInput
	      });
	
	      if (typeof InputComponent !== 'string') {
	        inputProps = (0, _extends2.default)({
	          // Rename ref to inputRef as we don't know the
	          // provided `inputComponent` structure.
	          inputRef: this.handleRefInput,
	          type: type
	        }, inputProps, {
	          ref: null
	        });
	      } else if (multiline) {
	        if (rows && !rowsMax) {
	          InputComponent = 'textarea';
	        } else {
	          inputProps = (0, _extends2.default)({
	            rowsMax: rowsMax,
	            textareaRef: this.handleRefInput
	          }, inputProps, {
	            ref: null
	          });
	          InputComponent = _Textarea.default;
	        }
	      } else {
	        inputProps = (0, _extends2.default)({
	          type: type
	        }, inputProps);
	      }
	
	      return _react.default.createElement("div", (0, _extends2.default)({
	        className: className,
	        onClick: this.handleClick
	      }, other), renderPrefix ? renderPrefix((0, _extends2.default)({}, fcs, {
	        startAdornment: startAdornment,
	        focused: this.state.focused
	      })) : null, startAdornment, _react.default.createElement(InputComponent, (0, _extends2.default)({
	        "aria-invalid": fcs.error,
	        autoComplete: autoComplete,
	        autoFocus: autoFocus,
	        className: inputClassName,
	        defaultValue: defaultValue,
	        disabled: fcs.disabled,
	        id: id,
	        name: name,
	        onBlur: this.handleBlur,
	        onChange: this.handleChange,
	        onFocus: this.handleFocus,
	        onKeyDown: onKeyDown,
	        onKeyUp: onKeyUp,
	        placeholder: placeholder,
	        readOnly: readOnly,
	        required: fcs.required,
	        rows: rows,
	        value: value
	      }, inputProps)), endAdornment);
	    }
	  }]);
	  return InputBase;
	}(_react.default.Component);
	
	InputBase.propTypes =  false ? {
	  /**
	   * This property helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it here:
	   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the input will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the wrapper element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default input value, useful when not controlling the component.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the native input.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Attributes applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value`.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEmpty: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFilled: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  renderPrefix: _propTypes.default.func,
	
	  /**
	   * If `true`, the input will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the input element. It should be a valid HTML5 input type.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The input value, required for a controlled component.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
	} : {};
	InputBase.defaultProps = {
	  fullWidth: false,
	  inputComponent: 'input',
	  multiline: false,
	  type: 'text'
	};
	InputBase.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	InputBase.childContextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputBase'
	})(InputBase);
	
	exports.default = _default;

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _debounce = _interopRequireDefault(__webpack_require__(50));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(43));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _reactHelpers = __webpack_require__(24);
	
	// < 1kb payload overhead when lodash/debounce is > 3kb.
	var ROWS_HEIGHT = 19;
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    position: 'relative',
	    // because the shadow has position: 'absolute',
	    width: '100%'
	  },
	  textarea: {
	    width: '100%',
	    height: '100%',
	    resize: 'none',
	    font: 'inherit',
	    padding: 0,
	    cursor: 'inherit',
	    boxSizing: 'border-box',
	    lineHeight: 'inherit',
	    border: 'none',
	    outline: 'none',
	    background: 'transparent'
	  },
	  shadow: {
	    // Overflow also needed to here to remove the extra row
	    // added to textareas in Firefox.
	    overflow: 'hidden',
	    // Visibility needed to hide the extra text area on ipads
	    visibility: 'hidden',
	    position: 'absolute',
	    height: 'auto',
	    whiteSpace: 'pre-wrap'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var Textarea =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Textarea, _React$Component);
	
	  function Textarea(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Textarea);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Textarea).call(this));
	
	    _this.handleRefInput = function (ref) {
	      _this.inputRef = ref;
	      (0, _reactHelpers.setRef)(_this.props.textareaRef, ref);
	    };
	
	    _this.handleRefSinglelineShadow = function (ref) {
	      _this.singlelineShadowRef = ref;
	    };
	
	    _this.handleRefShadow = function (ref) {
	      _this.shadowRef = ref;
	    };
	
	    _this.handleChange = function (event) {
	      _this.value = event.target.value;
	
	      if (!_this.isControlled) {
	        // The component is not controlled, we need to update the shallow value.
	        _this.shadowRef.value = _this.value;
	
	        _this.syncHeightWithShadow();
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    };
	
	    _this.isControlled = props.value != null; // <Input> expects the components it renders to respond to 'value'
	    // so that it can check whether they are filled.
	
	    _this.value = props.value || props.defaultValue || '';
	    _this.state = {
	      height: Number(props.rows) * ROWS_HEIGHT
	    };
	
	    if (typeof window !== 'undefined') {
	      _this.handleResize = (0, _debounce.default)(function () {
	        _this.syncHeightWithShadow();
	      }, 166); // Corresponds to 10 frames at 60 Hz.
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Textarea, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.clear();
	    }
	  }, {
	    key: "syncHeightWithShadow",
	    value: function syncHeightWithShadow() {
	      var props = this.props; // Guarding for **broken** shallow rendering method that call componentDidMount
	      // but doesn't handle refs correctly.
	      // To remove once the shallow rendering has been fixed.
	
	      if (!this.shadowRef) {
	        return;
	      }
	
	      if (this.isControlled) {
	        // The component is controlled, we need to update the shallow value.
	        this.shadowRef.value = props.value == null ? '' : String(props.value);
	      }
	
	      var lineHeight = this.singlelineShadowRef.scrollHeight;
	      var newHeight = this.shadowRef.scrollHeight; // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	
	      if (newHeight === undefined) {
	        return;
	      }
	
	      if (Number(props.rowsMax) >= Number(props.rows)) {
	        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, lineHeight); // Need a large enough different to update the height.
	      // This prevents infinite rendering loop.
	
	      if (Math.abs(this.state.height - newHeight) > 1) {
	        this.setState({
	          height: newHeight
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          classes = _this$props.classes,
	          className = _this$props.className,
	          defaultValue = _this$props.defaultValue,
	          onChange = _this$props.onChange,
	          rows = _this$props.rows,
	          rowsMax = _this$props.rowsMax,
	          textareaRef = _this$props.textareaRef,
	          value = _this$props.value,
	          style = _this$props.style,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "defaultValue", "onChange", "rows", "rowsMax", "textareaRef", "value", "style"]);
	      return _react.default.createElement("div", {
	        className: classes.root
	      }, _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }), _react.default.createElement("textarea", {
	        "aria-hidden": "true",
	        className: (0, _classnames.default)(classes.textarea, classes.shadow),
	        readOnly: true,
	        ref: this.handleRefSinglelineShadow,
	        rows: "1",
	        tabIndex: -1,
	        value: ""
	      }), _react.default.createElement("textarea", {
	        "aria-hidden": "true",
	        className: (0, _classnames.default)(classes.textarea, classes.shadow),
	        defaultValue: defaultValue,
	        readOnly: true,
	        ref: this.handleRefShadow,
	        rows: rows,
	        tabIndex: -1,
	        value: value
	      }), _react.default.createElement("textarea", (0, _extends2.default)({
	        rows: rows,
	        className: (0, _classnames.default)(classes.textarea, className),
	        defaultValue: defaultValue,
	        value: value,
	        onChange: this.handleChange,
	        ref: this.handleRefInput,
	        style: (0, _extends2.default)({
	          height: this.state.height
	        }, style)
	      }, other)));
	    }
	  }]);
	  return Textarea;
	}(_react.default.Component);
	
	Textarea.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Use that property to pass a ref callback to the native textarea element.
	   */
	  textareaRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * @ignore
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
	} : {};
	Textarea.defaultProps = {
	  rows: 1
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTextarea'
	})(Textarea);
	
	exports.default = _default;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	
	var _InputBase = _interopRequireDefault(__webpack_require__(37));

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValue = hasValue;
	exports.isFilled = isFilled;
	exports.isAdornedStart = isAdornedStart;
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	} // Determine if field is empty or filled.
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	
	
	function isFilled(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	} // Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	
	
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(124));
	
	var _InputBase = __webpack_require__(37);
	
	// @inheritedComponent FormLabel
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, 24px) scale(1)'
	    },
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, 21px) scale(1)'
	    },
	
	    /* Styles applied to the `input` element if `shrink={true}`. */
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the `input` element if `disableAnimation={false}`. */
	    animated: {
	      transition: theme.transitions.create(['color', 'transform'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the root element if `variant="filled"`. */
	    filled: {
	      // Chrome's autofill feature gives the input field a yellow background.
	      // Since the input field is behind the label in the HTML tree,
	      // the input field is drawn last and hides the label with an opaque background color.
	      // zIndex: 1 will raise the label above opaque background-colors of input.
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(12px, 22px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(12px, 19px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(12px, 10px) scale(0.75)',
	        '&$marginDense': {
	          transform: 'translate(12px, 7px) scale(0.75)'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      // see comment above on filled.zIndex
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(14px, 22px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(14px, 17.5px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(14px, -6px) scale(0.75)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function InputLabel(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableAnimation = props.disableAnimation,
	      FormLabelClasses = props.FormLabelClasses,
	      margin = props.margin,
	      shrinkProp = props.shrink,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "shrink", "variant"]);
	  var muiFormControl = context.muiFormControl;
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var fcs = (0, _InputBase.formControlState)({
	    props: props,
	    context: context,
	    states: ['margin', 'variant']
	  });
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, fcs.variant === 'outlined'), _classNames), classNameProp);
	  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: className,
	    classes: FormLabelClasses
	  }, other), children);
	}
	
	InputLabel.propTypes =  false ? {
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * `classes` property applied to the [`FormLabel`](/api/form-label/) element.
	   */
	  FormLabelClasses: _propTypes.default.object,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : {};
	InputLabel.defaultProps = {
	  disableAnimation: false
	};
	InputLabel.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(131));

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(62));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(18));
	
	var _keycode = _interopRequireDefault(__webpack_require__(93));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(23));
	
	var _RootRef = _interopRequireDefault(__webpack_require__(82));
	
	var _Portal = _interopRequireDefault(__webpack_require__(64));
	
	var _helpers = __webpack_require__(21);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(38));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(72));
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container) || defaultContainer;
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/* istanbul ignore if */
	
	
	exports.styles = styles;
	
	if (false) {
	  throw new Error('Material-UI: react@16.3.0 or greater is required.');
	}
	/**
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	var Modal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Modal, _React$Component);
	
	  function Modal(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Modal);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
	    _this.mounted = false;
	
	    _this.handleOpen = function () {
	      var doc = (0, _ownerDocument.default)(_this.mountNode);
	      var container = getContainer(_this.props.container, doc.body);
	
	      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);
	
	      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
	      doc.addEventListener('focus', _this.enforceFocus, true);
	
	      if (_this.dialogRef) {
	        _this.handleOpened();
	      }
	    };
	
	    _this.handleRendered = function () {
	      if (_this.props.onRendered) {
	        _this.props.onRendered();
	      }
	
	      if (_this.props.open) {
	        _this.handleOpened();
	      } else {
	        var doc = (0, _ownerDocument.default)(_this.mountNode);
	        var container = getContainer(_this.props.container, doc.body);
	
	        _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);
	
	        _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	      }
	    };
	
	    _this.handleOpened = function () {
	      _this.autoFocus(); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	
	      _this.modalRef.scrollTop = 0;
	    };
	
	    _this.handleClose = function () {
	      _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	
	      var doc = (0, _ownerDocument.default)(_this.mountNode);
	      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
	      doc.removeEventListener('focus', _this.enforceFocus, true);
	
	      _this.restoreLastFocus();
	    };
	
	    _this.handleExited = function () {
	      _this.setState({
	        exited: true
	      });
	    };
	
	    _this.handleBackdropClick = function (event) {
	      if (event.target !== event.currentTarget) {
	        return;
	      }
	
	      if (_this.props.onBackdropClick) {
	        _this.props.onBackdropClick(event);
	      }
	
	      if (!_this.props.disableBackdropClick && _this.props.onClose) {
	        _this.props.onClose(event, 'backdropClick');
	      }
	    };
	
	    _this.handleDocumentKeyDown = function (event) {
	      // Ignore events that have been `event.preventDefault()` marked.
	      if ((0, _keycode.default)(event) !== 'esc' || !_this.isTopModal() || event.defaultPrevented) {
	        return;
	      }
	
	      if (_this.props.onEscapeKeyDown) {
	        _this.props.onEscapeKeyDown(event);
	      }
	
	      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
	        _this.props.onClose(event, 'escapeKeyDown');
	      }
	    };
	
	    _this.enforceFocus = function () {
	      // The Modal might not already be mounted.
	      if (!_this.isTopModal() || _this.props.disableEnforceFocus || !_this.mounted || !_this.dialogRef) {
	        return;
	      }
	
	      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;
	
	      if (!_this.dialogRef.contains(currentActiveElement)) {
	        _this.dialogRef.focus();
	      }
	    };
	
	    _this.state = {
	      exited: !props.open
	    };
	    return _this;
	  }
	
	  (0, _createClass2.default)(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      if (this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.open && !this.props.open) {
	        this.handleClose();
	      } else if (!prevProps.open && this.props.open) {
	        // check for focus
	        this.lastFocus = (0, _ownerDocument.default)(this.mountNode).activeElement;
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: "autoFocus",
	    value: function autoFocus() {
	      // We might render an empty child.
	      if (this.props.disableAutoFocus || !this.dialogRef) {
	        return;
	      }
	
	      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;
	
	      if (!this.dialogRef.contains(currentActiveElement)) {
	        if (!this.dialogRef.hasAttribute('tabIndex')) {
	           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
	          this.dialogRef.setAttribute('tabIndex', -1);
	        }
	
	        this.lastFocus = currentActiveElement;
	        this.dialogRef.focus();
	      }
	    }
	  }, {
	    key: "restoreLastFocus",
	    value: function restoreLastFocus() {
	      if (this.props.disableRestoreFocus || !this.lastFocus) {
	        return;
	      } // Not all elements in IE 11 have a focus method.
	      // Because IE 11 market share is low, we accept the restore focus being broken
	      // and we silent the issue.
	
	
	      if (this.lastFocus.focus) {
	        this.lastFocus.focus();
	      }
	
	      this.lastFocus = null;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal() {
	      return this.props.manager.isTopModal(this);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          BackdropComponent = _this$props.BackdropComponent,
	          BackdropProps = _this$props.BackdropProps,
	          children = _this$props.children,
	          classes = _this$props.classes,
	          className = _this$props.className,
	          container = _this$props.container,
	          disableAutoFocus = _this$props.disableAutoFocus,
	          disableBackdropClick = _this$props.disableBackdropClick,
	          disableEnforceFocus = _this$props.disableEnforceFocus,
	          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
	          disablePortal = _this$props.disablePortal,
	          disableRestoreFocus = _this$props.disableRestoreFocus,
	          hideBackdrop = _this$props.hideBackdrop,
	          keepMounted = _this$props.keepMounted,
	          manager = _this$props.manager,
	          onBackdropClick = _this$props.onBackdropClick,
	          onClose = _this$props.onClose,
	          onEscapeKeyDown = _this$props.onEscapeKeyDown,
	          onRendered = _this$props.onRendered,
	          open = _this$props.open,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	      var exited = this.state.exited;
	      var hasTransition = getHasTransition(this.props);
	
	      if (!keepMounted && !open && (!hasTransition || exited)) {
	        return null;
	      }
	
	      var childProps = {}; // It's a Transition like component
	
	      if (hasTransition) {
	        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
	      }
	
	      if (children.props.role === undefined) {
	        childProps.role = children.props.role || 'document';
	      }
	
	      if (children.props.tabIndex === undefined) {
	        childProps.tabIndex = children.props.tabIndex || '-1';
	      }
	
	      return _react.default.createElement(_Portal.default, {
	        ref: function ref(_ref2) {
	          _this2.mountNode = _ref2 ? _ref2.getMountNode() : _ref2;
	        },
	        container: container,
	        disablePortal: disablePortal,
	        onRendered: this.handleRendered
	      }, _react.default.createElement("div", (0, _extends2.default)({
	        ref: function ref(_ref) {
	          _this2.modalRef = _ref;
	        },
	        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
	      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
	        open: open,
	        onClick: this.handleBackdropClick
	      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
	        rootRef: function rootRef(ref) {
	          _this2.dialogRef = ref;
	        }
	      }, _react.default.cloneElement(children, childProps))));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if (nextProps.open) {
	        return {
	          exited: false
	        };
	      }
	
	      if (!getHasTransition(nextProps)) {
	        // Otherwise let handleExited take care of marking exited.
	        return {
	          exited: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes =  false ? {
	  /**
	   * A backdrop component. This property enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Properties applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This property can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * A modal manager used to track and manage the state of open
	   * Modals. This enables customizing how modals interact within a container.
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` property took effect.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : {};
	Modal.defaultProps = {
	  BackdropComponent: _Backdrop.default,
	  disableAutoFocus: false,
	  disableBackdropClick: false,
	  disableEnforceFocus: false,
	  disableEscapeKeyDown: false,
	  disablePortal: false,
	  disableRestoreFocus: false,
	  hideBackdrop: false,
	  keepMounted: false,
	  // Modals don't open on the server so this won't conflict with concurrent requests.
	  manager: new _ModalManager.default()
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiModal'
	})(Modal);
	
	exports.default = _default;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _style = _interopRequireDefault(__webpack_require__(182));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(183));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(23));
	
	var _isOverflowing = _interopRequireDefault(__webpack_require__(77));
	
	var _manageAriaHidden = __webpack_require__(78);
	
	function findIndexOf(data, callback) {
	  var idx = -1;
	  data.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function getPaddingRight(node) {
	  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
	}
	
	function setContainerStyle(data, container) {
	  var style = {
	    overflow: 'hidden'
	  }; // We are only interested in the actual `style` here because we will override it.
	
	  data.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (data.overflowing) {
	    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.
	
	    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	
	    for (var i = 0; i < fixedNodes.length; i += 1) {
	      var paddingRight = getPaddingRight(fixedNodes[i]);
	      data.prevPaddings.push(paddingRight);
	      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
	    }
	  }
	
	  Object.keys(style).forEach(function (key) {
	    container.style[key] = style[key];
	  });
	}
	
	function removeContainerStyle(data) {
	  Object.keys(data.style).forEach(function (key) {
	    data.container.style[key] = data.style[key];
	  });
	  var fixedNodes = (0, _ownerDocument.default)(data.container).querySelectorAll('.mui-fixed');
	
	  for (var i = 0; i < fixedNodes.length; i += 1) {
	    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
	  }
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state managment for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager =
	/*#__PURE__*/
	function () {
	  function ModalManager() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ModalManager);
	    var _options$hideSiblingN = options.hideSiblingNodes,
	        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
	        _options$handleContai = options.handleContainerOverflow,
	        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal
	
	    this.modals = []; // this.data[containerIdx] = {
	    //   modals: [],
	    //   container,
	    //   overflowing,
	    //   prevPaddings,
	    // }
	
	    this.data = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        (0, _manageAriaHidden.ariaHidden)(modal.modalRef, false);
	      }
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.ariaHiddenSiblings)(container, modal.mountNode, modal.modalRef, true);
	      }
	
	      var containerIdx = findIndexOf(this.data, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        container: container,
	        overflowing: (0, _isOverflowing.default)(container),
	        prevPaddings: []
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      this.data.push(data);
	      return modalIdx;
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return modalIdx;
	      }
	
	      var containerIdx = findIndexOf(this.data, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var data = this.data[containerIdx];
	      data.modals.splice(data.modals.indexOf(modal), 1);
	      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.
	
	      if (data.modals.length === 0) {
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data);
	        } // In case the modal wasn't in the DOM yet.
	
	
	        if (modal.modalRef) {
	          (0, _manageAriaHidden.ariaHidden)(modal.modalRef, true);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.ariaHiddenSiblings)(data.container, modal.mountNode, modal.modalRef, false);
	        }
	
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        // Otherwise make sure the next top modal is visible to a screan reader.
	        (0, _manageAriaHidden.ariaHidden)(data.modals[data.modals.length - 1].modalRef, false);
	      }
	
	      return modalIdx;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	var _default = ModalManager;
	exports.default = _default;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(75));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(38));

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isBody = isBody;
	exports.default = isOverflowing;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(107));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(23));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(54));
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	} // Do we have a vertical scroll bar?
	
	
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	  var win = (0, _ownerWindow.default)(doc);
	  /* istanbul ignore next */
	
	  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
	    return container.scrollHeight > container.clientHeight;
	  } // Takes in account potential non zero margin on the body.
	
	
	  var style = win.getComputedStyle(doc.body);
	  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
	  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
	  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
	}

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.ariaHiddenSiblings = ariaHiddenSiblings;
	var BLACKLIST = ['template', 'script', 'style'];
	
	function isHidable(node) {
	  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
	}
	
	function siblings(container, mount, currentNode, callback) {
	  var blacklist = [mount, currentNode]; // eslint-disable-line no-param-reassign
	
	  [].forEach.call(container.children, function (node) {
	    if (blacklist.indexOf(node) === -1 && isHidable(node)) {
	      callback(node);
	    }
	  });
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode, show) {
	  siblings(container, mountNode, currentNode, function (node) {
	    return ariaHidden(node, show);
	  });
	}

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	
	function Paper(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      square = props.square,
	      elevation = props.elevation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
	   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
	  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other));
	}
	
	Paper.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It's accepting values between 0 and 24 inclusive.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool
	} : {};
	Paper.defaultProps = {
	  component: 'div',
	  elevation: 2,
	  square: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(79));

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(23));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(35));
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container) || defaultContainer;
	}
	
	function getOwnerDocument(element) {
	  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
	}
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	
	var Portal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Portal, _React$Component);
	
	  function Portal() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Portal);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _this.getMountNode = function () {
	      return _this.mountNode;
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setMountNode(this.props.container); // Only rerender if needed
	
	      if (!this.props.disablePortal) {
	        this.forceUpdate(this.props.onRendered);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
	        this.setMountNode(this.props.container); // Only rerender if needed
	
	        if (!this.props.disablePortal) {
	          this.forceUpdate(this.props.onRendered);
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mountNode = null;
	    }
	  }, {
	    key: "setMountNode",
	    value: function setMountNode(container) {
	      if (this.props.disablePortal) {
	        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
	        return;
	      }
	
	      this.mountNode = getContainer(container, getOwnerDocument(this).body);
	    }
	    /**
	     * @public
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          disablePortal = _this$props.disablePortal;
	
	      if (disablePortal) {
	        return children;
	      }
	
	      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
	    }
	  }]);
	  return Portal;
	}(_react.default.Component);
	
	Portal.propTypes =  false ? {
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   */
	  onRendered: _propTypes.default.func
	} : {};
	Portal.defaultProps = {
	  disablePortal: false
	};
	Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes) : {};
	var _default = Portal;
	exports.default = _default;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(80));

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(19));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(35));
	
	var _reactHelpers = __webpack_require__(24);
	
	/**
	 * Helper component to allow attaching a ref to a
	 * wrapped element to access the underlying DOM element.
	 *
	 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
	 * For example:
	 * ```jsx
	 * import React from 'react';
	 * import RootRef from '@material-ui/core/RootRef';
	 *
	 * class MyComponent extends React.Component {
	 *   constructor() {
	 *     super();
	 *     this.domRef = React.createRef();
	 *   }
	 *
	 *   componentDidMount() {
	 *     console.log(this.domRef.current); // DOM node
	 *   }
	 *
	 *   render() {
	 *     return (
	 *       <RootRef rootRef={this.domRef}>
	 *         <SomeChildComponent />
	 *       </RootRef>
	 *     );
	 *   }
	 * }
	 * ```
	 */
	var RootRef =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ref = _reactDom.default.findDOMNode(this);
	      (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var ref = _reactDom.default.findDOMNode(this);
	
	      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
	        if (prevProps.rootRef !== this.props.rootRef) {
	          (0, _reactHelpers.setRef)(prevProps.rootRef, null);
	        }
	
	        this.ref = ref;
	        (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.ref = null;
	      (0, _reactHelpers.setRef)(this.props.rootRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(_react.default.Component);
	
	RootRef.propTypes =  false ? {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Provide a way to access the DOM node of the wrapped element.
	   * You can provide a callback ref or a `React.createRef()` ref.
	   */
	  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
	} : {};
	RootRef.propTypes =  false ? (0, _exactProp.default)(RootRef.propTypes) : {};
	var _default = RootRef;
	exports.default = _default;

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(81));

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(19));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(43));
	
	var _debounce = _interopRequireDefault(__webpack_require__(50));
	
	var _Transition = _interopRequireDefault(__webpack_require__(52));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(54));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(29));
	
	var _transitions = __webpack_require__(31);
	
	var _utils = __webpack_require__(34);
	
	// @inheritedComponent Transition
	// < 1kb payload overhead when lodash/debounce is > 3kb.
	var GUTTER = 24; // Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `translate3d(0, 0, 0)`.`
	
	function getTranslateValue(props, node) {
	  var direction = props.direction;
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
	}
	
	function setTranslateValue(props, node) {
	  var transform = getTranslateValue(props, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	/**
	 * The Slide transition is used by the [Snackbar](/demos/snackbars/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	var Slide =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Slide, _React$Component);
	
	  function Slide() {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Slide);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Slide).call(this));
	    _this.mounted = false;
	
	    _this.handleEnter = function (node) {
	      setTranslateValue(_this.props, node);
	      (0, _utils.reflow)(node);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    };
	
	    _this.handleEntering = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.easeOut
	      }));
	      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.easeOut
	      }));
	      node.style.webkitTransform = 'translate(0, 0)';
	      node.style.transform = 'translate(0, 0)';
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    };
	
	    _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.sharp
	      }));
	      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.sharp
	      }));
	      setTranslateValue(_this.props, node);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.handleExited = function (node) {
	      // No need for transitions when the component is hidden
	      node.style.webkitTransition = '';
	      node.style.transition = '';
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    if (typeof window !== 'undefined') {
	      _this.handleResize = (0, _debounce.default)(function () {
	        // Skip configuration where the position is screen size invariant.
	        if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
	          return;
	        }
	
	        if (_this.transitionRef) {
	          setTranslateValue(_this.props, _this.transitionRef);
	        }
	      }, 166); // Corresponds to 10 frames at 60 Hz.
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Slide, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true; // state.mounted handle SSR, once the component is mounted, we need
	      // to properly hide it.
	
	      if (!this.props.in) {
	        // We need to set initial translate values of transition element
	        // otherwise component will be shown when in=false.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.direction !== this.props.direction && !this.props.in) {
	        // We need to update the position of the drawer when the direction change and
	        // when it's hidden.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.clear();
	    }
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      if (this.transitionRef) {
	        this.transitionRef.style.visibility = 'inherit';
	        setTranslateValue(this.props, this.transitionRef);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          onEnter = _this$props.onEnter,
	          onEntering = _this$props.onEntering,
	          onExit = _this$props.onExit,
	          onExited = _this$props.onExited,
	          styleProp = _this$props.style,
	          theme = _this$props.theme,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
	      var style = {}; // We use this state to handle the server-side rendering.
	      // We don't know the width of the children ahead of time.
	      // We need to render it.
	
	      if (!this.props.in && !this.mounted) {
	        style.visibility = 'hidden';
	      }
	
	      style = (0, _extends2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExited: this.handleExited,
	        appear: true,
	        style: style,
	        ref: function ref(_ref) {
	          _this2.transitionRef = _reactDom.default.findDOMNode(_ref);
	        }
	      }, other), children));
	    }
	  }]);
	  return Slide;
	}(_react.default.Component);
	
	Slide.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Slide.defaultProps = {
	  direction: 'down',
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()(Slide);
	
	exports.default = _default;

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(83));

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(4));
	
	var _helpers = __webpack_require__(21);
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(162));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="display4"`. */
	    display4: theme.typography.display4,
	
	    /* Styles applied to the root element if `variant="display3"`. */
	    display3: theme.typography.display3,
	
	    /* Styles applied to the root element if `variant="display2"`. */
	    display2: theme.typography.display2,
	
	    /* Styles applied to the root element if `variant="display1"`. */
	    display1: theme.typography.display1,
	
	    /* Styles applied to the root element if `variant="headline"`. */
	    headline: theme.typography.headline,
	
	    /* Styles applied to the root element if `variant="title"`. */
	    title: theme.typography.title,
	
	    /* Styles applied to the root element if `variant="subheading"`. */
	    subheading: theme.typography.subheading,
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `variant="h1"`. */
	    h1: theme.typography.h1,
	
	    /* Styles applied to the root element if `variant="h2"`. */
	    h2: theme.typography.h2,
	
	    /* Styles applied to the root element if `variant="h3"`. */
	    h3: theme.typography.h3,
	
	    /* Styles applied to the root element if `variant="h4"`. */
	    h4: theme.typography.h4,
	
	    /* Styles applied to the root element if `variant="h5"`. */
	    h5: theme.typography.h5,
	
	    /* Styles applied to the root element if `variant="h6"`. */
	    h6: theme.typography.h6,
	
	    /* Styles applied to the root element if `variant="subtitle1"`. */
	    subtitle1: theme.typography.subtitle1,
	
	    /* Styles applied to the root element if `variant="subtitle2"`. */
	    subtitle2: theme.typography.subtitle2,
	
	    /* Styles applied to the root element if `variant="overline"`. */
	    overline: theme.typography.overline,
	
	    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
	    srOnly: {
	      position: 'absolute',
	      height: 1,
	      width: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `align="nowrap"`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    }
	  };
	};
	
	exports.styles = styles;
	var nextVariants = {
	  display4: 'h1',
	  display3: 'h2',
	  display2: 'h3',
	  display1: 'h4',
	  headline: 'h5',
	  title: 'h6',
	  subheading: 'subtitle1'
	};
	
	function getVariant(theme, variantProp) {
	  var typography = theme.typography;
	  var variant = variantProp;
	
	  if (!variant) {
	    variant = typography.useNextVariants ? 'body2' : 'body1';
	  } // complete v2 switch
	
	
	  if (typography.useNextVariants) {
	    variant = nextVariants[variant] || variant;
	  }
	
	  return variant;
	}
	
	var defaultHeadlineMapping = {
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  subtitle1: 'h6',
	  subtitle2: 'h6',
	  body1: 'p',
	  body2: 'p',
	  // deprecated
	  display4: 'h1',
	  display3: 'h1',
	  display2: 'h1',
	  display1: 'h1',
	  headline: 'h1',
	  title: 'h2',
	  subheading: 'h3'
	};
	
	function Typography(props) {
	  var _classNames;
	
	  var align = props.align,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      componentProp = props.component,
	      gutterBottom = props.gutterBottom,
	      headlineMapping = props.headlineMapping,
	      internalDeprecatedVariant = props.internalDeprecatedVariant,
	      noWrap = props.noWrap,
	      paragraph = props.paragraph,
	      theme = props.theme,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "internalDeprecatedVariant", "noWrap", "paragraph", "theme", "variant"]);
	  var variant = getVariant(theme, variantProp);
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes[variant], variant !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
	  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant] || defaultHeadlineMapping[variant]) || 'span';
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other));
	}
	
	Typography.propTypes =  false ? {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it maps the variant to a good default headline component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * We are empirically mapping the variant property to a range of different DOM element types.
	   * For instance, subtitle1 to `<h6>`.
	   * If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` property.
	   * The default mapping is the following:
	   */
	  headlineMapping: _propTypes.default.object,
	
	  /**
	   * A deprecated variant is used from an internal component. Users don't need
	   * a deprecation warning here if they switched to the v2 theme. They already
	   * get the mapping that will be applied in the next major release.
	   *
	   * @internal
	   */
	  internalDeprecatedVariant: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   * Use `body1` as the default value with the legacy implementation and `body2` with the new one.
	   */
	  variant: (0, _chainPropTypes.default)(_propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit', // deprecated
	  'display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading']), function (props) {
	    var deprecatedVariants = ['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading'];
	
	    if (props.theme.typography.useNextVariants && !props.internalDeprecatedVariant && deprecatedVariants.indexOf(props.variant) !== -1) {
	      return new Error('You are using a deprecated typography variant: ' + "`".concat(props.variant, "` that will be removed in the next major release.") + '\nPlease read the migration guide under https://material-ui.com/style/typography#migration-to-typography-v2');
	    }
	
	    return null;
	  })
	} : {};
	Typography.defaultProps = {
	  align: 'inherit',
	  color: 'default',
	  gutterBottom: false,
	  headlineMapping: defaultHeadlineMapping,
	  noWrap: false,
	  paragraph: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography',
	  withTheme: true
	})(Typography);
	
	exports.default = _default;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(133));

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(11));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(61));
	
	var _wrapDisplayName = _interopRequireDefault(__webpack_require__(70));
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(95));
	
	var _themeListener = _interopRequireDefault(__webpack_require__(96));
	
	var defaultTheme;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme.default)();
	  return defaultTheme;
	} // Provide the theme object as a property to the input component.
	
	
	var withTheme = function withTheme() {
	  return function (Component) {
	    var WithTheme =
	    /*#__PURE__*/
	    function (_React$Component) {
	      (0, _inherits2.default)(WithTheme, _React$Component);
	
	      function WithTheme(props, context) {
	        var _this;
	
	        (0, _classCallCheck2.default)(this, WithTheme);
	        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
	        _this.state = {
	          // We use || as the function call is lazy evaluated.
	          theme: _themeListener.default.initial(context) || getDefaultTheme()
	        };
	        return _this;
	      }
	
	      (0, _createClass2.default)(WithTheme, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
	            _this2.setState({
	              theme: theme
	            });
	          });
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          if (this.unsubscribeId !== null) {
	            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
	          }
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          var _this$props = this.props,
	              innerRef = _this$props.innerRef,
	              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
	          return _react.default.createElement(Component, (0, _extends2.default)({
	            theme: this.state.theme,
	            ref: innerRef
	          }, other));
	        }
	      }]);
	      return WithTheme;
	    }(_react.default.Component);
	
	    WithTheme.propTypes =  false ? {
	      /**
	       * Use that property to pass a ref callback to the decorated component.
	       */
	      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
	    } : {};
	    WithTheme.contextTypes = _themeListener.default.contextTypes;
	
	    if (false) {
	      WithTheme.displayName = (0, _wrapDisplayName.default)(Component, 'WithTheme');
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	};
	
	var _default = withTheme;
	exports.default = _default;

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
	    delay: style.transitionDelay
	  };
	}

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneElementWithClassName = cloneElementWithClassName;
	exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
	exports.isMuiElement = isMuiElement;
	exports.setRef = setRef;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	/* eslint-disable import/prefer-default-export */
	function cloneElementWithClassName(child, className) {
	  return _react.default.cloneElement(child, {
	    className: (0, _classnames.default)(child.props.className, className)
	  });
	}
	
	function cloneChildrenWithClassName(children, className) {
	  return _react.default.Children.map(children, function (child) {
	    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
	  });
	}
	
	function isMuiElement(element, muiNames) {
	  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}
	
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	}), _react.default.createElement("path", {
	  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
	})), 'Check');
	
	exports.default = _default;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	})), 'Clear');
	
	exports.default = _default;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
	})), 'CloudDownload');
	
	exports.default = _default;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	}), _react.default.createElement("path", {
	  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
	})), 'Done');
	
	exports.default = _default;

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ 800:
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(799),
	    deburr = __webpack_require__(804),
	    words = __webpack_require__(807);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),

/***/ 802:
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),

/***/ 803:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),

/***/ 806:
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),

/***/ 804:
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(801);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(800),
	    hasUnicodeWord = __webpack_require__(802),
	    toString = __webpack_require__(806),
	    unicodeWords = __webpack_require__(803);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

	module.exports=function(e){function t(r){if(o[r])return o[r].exports;var n=o[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function n(e,t){var o={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(o[r]=e[r]);return o}function i(e){var t=(e.videoId,e.autoplay,e.suggestions,e.controls,e.showInfo,e.enhancedPrivacy,e.width),o=e.height,r=e.size,i=n(e,["videoId","autoplay","suggestions","controls","showInfo","enhancedPrivacy","width","height","size"]),h=u(e),d=a(t,o,r);return l.default.createElement("iframe",s({width:d.width,height:d.height,src:h,frameBorder:"0",allowFullScreen:!0,title:"Youtube Embed Video"},i))}function u(e){var t=[];return e.enhancedPrivacy?t.push("https://www.youtube-nocookie.com/embed/"):t.push("https://www.youtube.com/embed/"),t.push(e.videoId),t.push(e.autoplay?"?autoplay=1":"?autoplay=0"),e.suggestions||t.push("&rel=0"),e.controls||t.push("&controls=0"),e.showInfo||t.push("&showinfo=0"),t.join("")}function a(e,t,o){return o&&p.has(o.toLowerCase())?p.get(o.toLowerCase()):{width:e,height:t}}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var r in o)Object.prototype.hasOwnProperty.call(o,r)&&(e[r]=o[r])}return e},h=o(2),l=r(h),d=o(1),c=r(d),p=new Map([["small",{width:560,height:315}],["medium",{width:640,height:360}],["large",{width:853,height:480}],["largest",{width:1280,height:720}]]);i.propTypes={videoId:c.default.string.isRequired,width:c.default.number,height:c.default.number,size:c.default.string,autoplay:c.default.bool,enhancedPrivacy:c.default.bool,suggestions:c.default.bool,controls:c.default.bool,showInfo:c.default.bool},i.defaultProps={width:560,height:315,size:"",autoplay:!1,enhancedPrivacy:!1,suggestions:!0,controls:!0,showInfo:!0},t.default=i},function(e,t){e.exports=__webpack_require__(3)},function(e,t){e.exports=__webpack_require__(1)}]);
	//# sourceMappingURL=youtube.js.map

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bitnational_whitepaper.8fd3c4dd.pdf";

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _materialKitProReact = __webpack_require__(15);
	
	var customInputStyle = {
	  disabled: {
	    '&:before': {
	      backgroundColor: 'transparent !important'
	    }
	  },
	  underline: {
	    '&:hover:not($disabled):before,&:before': {
	      borderBottomColor: '#D2D2D2 !important',
	      borderBottomWidth: '1px !important'
	    },
	    '&:after': {
	      borderBottomColor: _materialKitProReact.primaryColor
	    }
	  },
	  underlineError: {
	    '&:after': {
	      borderBottomColor: _materialKitProReact.dangerColor
	    }
	  },
	  underlineSuccess: {
	    '&:after': {
	      borderBottomColor: _materialKitProReact.successColor
	    }
	  },
	  labelRoot: _extends({}, _materialKitProReact.defaultFont, {
	    color: '#AAAAAA !important',
	    fontWeight: '400',
	    fontSize: '14px',
	    lineHeight: '1.42857',
	    top: '10px',
	    '& + $underline': {
	      marginTop: '0px'
	    }
	  }),
	  labelRootError: {
	    color: _materialKitProReact.dangerColor + ' !important'
	  },
	  labelRootSuccess: {
	    color: _materialKitProReact.successColor + ' !important'
	  },
	  feedback: {
	    position: 'absolute',
	    bottom: '4px',
	    right: '0',
	    zIndex: '2',
	    display: 'block',
	    width: '24px',
	    height: '24px',
	    textAlign: 'center',
	    pointerEvents: 'none'
	  },
	  formControl: {
	    margin: '0 0 17px 0',
	    paddingTop: '27px',
	    position: 'relative',
	    '& svg,& .fab,& .far,& .fal,& .fas,& .material-icons': {
	      color: '#495057'
	    }
	  },
	  whiteUnderline: {
	    '&:hover:not($disabled):before,&:before': {
	      borderBottomColor: '#FFFFFF'
	    },
	    '&:after': {
	      borderBottomColor: '#FFFFFF'
	    }
	  },
	  input: {
	    color: '#495057',
	    '&,&::placeholder': {
	      fontSize: '14px',
	      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
	      fontWeight: '400',
	      lineHeight: '1.42857',
	      opacity: '1'
	    },
	    '&::placeholder': {
	      color: '#AAAAAA'
	    }
	  },
	  whiteInput: {
	    '&,&::placeholder': {
	      color: '#FFFFFF',
	      opacity: '1'
	    }
	  }
	};
	
	exports.default = customInputStyle;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ##############################
	// // // Info component styles
	// #############################
	
	var _materialKitProReact = __webpack_require__(15);
	
	var infoStyle = {
	  infoArea: {
	    maxWidth: '360px',
	    padding: '5px 0 0'
	  },
	  iconWrapper: {
	    float: 'left',
	    marginTop: '0',
	    marginRight: '10px'
	  },
	  primary: {
	    color: _materialKitProReact.primaryColor
	  },
	  warning: {
	    color: _materialKitProReact.warningColor
	  },
	  danger: {
	    color: _materialKitProReact.dangerColor
	  },
	  success: {
	    color: _materialKitProReact.successColor
	  },
	  info: {
	    color: _materialKitProReact.infoColor
	  },
	  rose: {
	    color: _materialKitProReact.roseColor
	  },
	  gray: {
	    color: _materialKitProReact.grayColor
	  },
	  icon: {
	    width: '2.25rem',
	    height: '2.25rem',
	    fontSize: '2.25rem'
	  },
	  descriptionWrapper: {
	    color: 'white',
	    overflow: 'hidden'
	  },
	  title: _extends({}, _materialKitProReact.title, {
	    margin: '4px 0 0.875rem !important',
	    minHeight: 'unset'
	  }),
	  description: {
	    color: _materialKitProReact.infoColor,
	    overflow: 'hidden',
	    marginTop: '0px',
	    '& p': {
	      color: _materialKitProReact.grayColor,
	      fontSize: '14px'
	    }
	  },
	  iconWrapperVertical: {
	    float: 'none'
	  },
	  iconVertical: {
	    width: '61px',
	    height: '61px'
	  }
	};
	
	exports.default = infoStyle;
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var modalStyle = function modalStyle(theme) {
	  var _modalRoot, _modal, _modalLarge, _modalSmall;
	
	  return {
	    modalRoot: (_modalRoot = {
	      overflow: 'auto',
	      display: 'block'
	    }, _modalRoot[theme.breakpoints.down('sm')] = {
	      padding: '0 1rem'
	    }, _modalRoot),
	    modal: (_modal = {}, _modal[theme.breakpoints.up('sm')] = {
	      maxWidth: '600px',
	      margin: '1.75rem auto'
	    }, _modal[theme.breakpoints.down('sm')] = {
	      marginRight: '0px !important',
	      marginLeft: '0px !important'
	    }, _modal.borderRadius = '6px', _modal.overflow = 'visible', _modal.maxHeight = 'unset', _modal.width = '100%', _modal.marginTop = '130px !important', _modal),
	    modalHeader: {
	      borderBottom: 'none',
	      paddingTop: '24px',
	      paddingRight: '24px',
	      paddingBottom: '0',
	      paddingLeft: '24px',
	      minHeight: '16.43px'
	    },
	    modalTitle: {
	      margin: '0',
	      lineHeight: '1.5'
	    },
	    modalCloseButton: {
	      '&, &:hover': {
	        color: '#999999'
	      },
	      '&:hover': {
	        opacity: '1'
	      },
	      cursor: 'pointer',
	      padding: '1rem',
	      margin: '-1rem -1rem -1rem auto',
	      backgroundColor: 'transparent',
	      border: '0',
	      WebkitAppearance: 'none',
	      float: 'right',
	      fontSize: '1.5rem',
	      fontWeight: '500',
	      lineHeight: '1',
	      textShadow: '0 1px 0 #ffffff',
	      opacity: '.5'
	    },
	    modalClose: {
	      width: '16px',
	      height: '16px'
	    },
	    modalBody: {
	      paddingTop: '24px',
	      paddingRight: '24px',
	      paddingBottom: '16px',
	      paddingLeft: '24px',
	      position: 'relative',
	      overflow: 'hidden'
	    },
	    modalFooter: {
	      padding: '15px',
	      textAlign: 'right',
	      paddingTop: '0',
	      margin: '0'
	    },
	    modalFooterCenter: {
	      marginLeft: 'auto',
	      marginRight: 'auto'
	    },
	    instructionNoticeModal: {
	      marginBottom: '25px'
	    },
	    imageNoticeModal: {
	      maxWidth: '150px'
	    },
	    modalLarge: (_modalLarge = {}, _modalLarge[theme.breakpoints.up('md')] = {
	      maxWidth: '800px'
	    }, _modalLarge),
	    modalSmall: (_modalSmall = {}, _modalSmall[theme.breakpoints.up('sm')] = {
	      width: '300px',
	      margin: '1.75rem auto'
	    }, _modalSmall.margin = '0 auto', _modalSmall),
	    modalSmallBody: {
	      marginTop: '20px'
	    },
	    modalSmallFooterFirstButton: {
	      margin: '0',
	      paddingLeft: '16px',
	      paddingRight: '16px',
	      width: 'auto'
	    },
	    modalSmallFooterSecondButton: {
	      marginBottom: '0',
	      marginLeft: '5px'
	    },
	    modalLogin: {
	      maxWidth: '420px',
	      maxHeight: '80vh',
	      height: '100%',
	      overflowY: 'visible',
	      width: '100%',
	      '& $modalCloseButton': {
	        color: '#fff',
	        top: '-10px',
	        right: '10px',
	        textShadow: 'none',
	        position: 'relative'
	      },
	      '& $modalHeader': {
	        borderBottom: 'none',
	        paddingTop: '24px',
	        paddingRight: '24px',
	        paddingBottom: '0',
	        paddingLeft: '24px'
	      },
	      '& $modalBody': {
	        paddingBottom: '0',
	        paddingTop: '0'
	      },
	      '& $modalFooter': {
	        paddingBottom: '0',
	        paddingTop: '0'
	      }
	    },
	    modalLoginCard: {
	      marginBottom: '0',
	      margin: '0',
	      '& $modalHeader': {
	        paddingTop: '0'
	      }
	    },
	    modalSignup: {
	      maxWidth: '900px',
	      width: '100%',
	      '& $modalHeader': {
	        paddingTop: '0'
	      },
	      '& $modalTitle': {
	        textAlign: 'center',
	        width: '100%',
	        marginTop: '0.625rem'
	      },
	      '& $modalBody': {
	        paddingBottom: '0',
	        paddingTop: '0'
	      }
	    },
	    modalSignupCard: {
	      padding: '40px 0',
	      margin: '0'
	    }
	  };
	};
	
	exports.default = modalStyle;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _materialKitProReact = __webpack_require__(15);
	
	var _imagesStyles = __webpack_require__(47);
	
	var _imagesStyles2 = _interopRequireDefault(_imagesStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = _extends({}, _imagesStyles2.default, {
	  container: _materialKitProReact.container,
	  title: _materialKitProReact.title,
	  description: _materialKitProReact.description,
	  section: _extends({}, _materialKitProReact.section, {
	    padding: '70px 0px'
	  }),
	  cdnimage: {
	    width: '1rem',
	    display: 'inline'
	  },
	  socialFeed: {
	    '& p': {
	      display: 'table-cell',
	      verticalAlign: 'top',
	      overflow: 'hidden',
	      paddingBottom: '10px',
	      maxWidth: 300
	    },
	    '& i': {
	      fontSize: '20px',
	      display: 'table-cell',
	      paddingRight: '10px'
	    }
	  },
	  img: {
	    width: '20%',
	    marginRight: '5%',
	    marginBottom: '5%',
	    float: 'left'
	  },
	  list: {
	    marginBottom: '0',
	    padding: '0',
	    marginTop: '0'
	  },
	  inlineBlock: {
	    display: 'inline-block',
	    padding: '0px',
	    width: 'auto'
	  },
	  left: {
	    float: 'left!important',
	    display: 'block'
	  },
	  right: {
	    padding: '15px 0',
	    margin: '0',
	    float: 'right'
	  },
	  aClass: {
	    textDecoration: 'none',
	    backgroundColor: 'transparent'
	  },
	  block: {
	    color: 'inherit',
	    padding: '0.9375rem',
	    fontWeight: '500',
	    fontSize: '12px',
	    textTransform: 'uppercase',
	    borderRadius: '3px',
	    textDecoration: 'none',
	    position: 'relative',
	    display: 'block'
	  },
	  footerBrand: {
	    height: '50px',
	    padding: '15px 15px',
	    fontSize: '18px',
	    lineHeight: '50px',
	    marginLeft: '-15px',
	    color: '#3c4858',
	    textDecoration: 'none',
	    fontWeight: 700,
	    fontFamily: 'Roboto Slab,Times New Roman,serif'
	  },
	  pullCenter: {
	    display: 'inline-block',
	    float: 'none'
	  },
	  rightLinks: {
	    float: 'right!important',
	    '& ul': {
	      marginBottom: 0,
	      padding: 0,
	      listStyle: 'none',
	      '& li': {
	        display: 'inline-block'
	      },
	      '& a': {
	        display: 'block'
	      }
	    },
	    '& i': {
	      fontSize: '20px'
	    }
	  },
	  linksVertical: {
	    '& li': {
	      display: 'block !important',
	      marginLeft: '-5px',
	      marginRight: '-5px',
	      '& a': {
	        padding: '5px !important'
	      }
	    }
	  },
	  footer: {
	    '& ul li': {
	      display: 'inline-block'
	    },
	    '& h4, & h5': {
	      color: '#fff',
	      textDecoration: 'none'
	    },
	    '& ul:not($socialButtons) li a': {
	      color: 'inherit',
	      padding: '0.9375rem',
	      fontWeight: '500',
	      fontSize: '12px',
	      textTransform: 'uppercase',
	      borderRadius: '3px',
	      textDecoration: 'none',
	      position: 'relative',
	      display: 'block'
	    },
	    '& small': {
	      fontSize: '75%',
	      color: '#777'
	    },
	    '& $pullCenter': {
	      display: 'inline-block',
	      float: 'none'
	    }
	  },
	  iconSocial: {
	    width: '41px',
	    height: '41px',
	    fontSize: '24px',
	    minWidth: '41px',
	    padding: 0,
	    overflow: 'hidden',
	    position: 'relative'
	  },
	  copyRight: {
	    padding: '15px 0px'
	  },
	  socialButtons: {
	    '& li': {
	      display: 'inline-block'
	    }
	  },
	  btnTwitter: _extends({}, _materialKitProReact.btnLink, {
	    color: '#55acee'
	  }),
	  btnDribbble: _extends({}, _materialKitProReact.btnLink, {
	    color: '#ea4c89'
	  }),
	  btnInstagram: _extends({}, _materialKitProReact.btnLink, {
	    color: '#125688'
	  }),
	  icon: {
	    top: '3px',
	    width: '18px',
	    height: '18px',
	    position: 'relative'
	  }
	});
	
	exports.default = style;
	module.exports = exports['default'];

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(4);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _FormControl = __webpack_require__(122);
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	var _InputLabel = __webpack_require__(132);
	
	var _InputLabel2 = _interopRequireDefault(_InputLabel);
	
	var _Input = __webpack_require__(128);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Clear = __webpack_require__(137);
	
	var _Clear2 = _interopRequireDefault(_Clear);
	
	var _Check = __webpack_require__(136);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _customInputStyle = __webpack_require__(139);
	
	var _customInputStyle2 = _interopRequireDefault(_customInputStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	// nodejs library to set properties for components
	
	// nodejs library that concatenates classes
	
	
	// @material-ui/core components
	
	// @material-ui/icons
	
	// core components
	
	function CustomInput(_ref) {
	  var _classNames, _classNames2, _classNames3, _classNames4;
	
	  var props = _objectWithoutProperties(_ref, []);
	
	  var classes = props.classes,
	      formControlProps = props.formControlProps,
	      labelText = props.labelText,
	      id = props.id,
	      labelProps = props.labelProps,
	      inputProps = props.inputProps,
	      error = props.error,
	      white = props.white,
	      inputRootCustomClasses = props.inputRootCustomClasses,
	      success = props.success;
	
	
	  var labelClasses = (0, _classnames2.default)((_classNames = {}, _classNames[' ' + classes.labelRootError] = error, _classNames[' ' + classes.labelRootSuccess] = success && !error, _classNames));
	  var underlineClasses = (0, _classnames2.default)((_classNames2 = {}, _classNames2[classes.underlineError] = error, _classNames2[classes.underlineSuccess] = success && !error, _classNames2[classes.underline] = true, _classNames2[classes.whiteUnderline] = white, _classNames2));
	  var marginTop = (0, _classnames2.default)((_classNames3 = {}, _classNames3[inputRootCustomClasses] = inputRootCustomClasses !== undefined, _classNames3));
	  var inputClasses = (0, _classnames2.default)((_classNames4 = {}, _classNames4[classes.input] = true, _classNames4[classes.whiteInput] = white, _classNames4));
	  var formControlClasses;
	  if (formControlProps !== undefined) {
	    formControlClasses = (0, _classnames2.default)(formControlProps.className, classes.formControl);
	  } else {
	    formControlClasses = classes.formControl;
	  }
	  return _react2.default.createElement(
	    _FormControl2.default,
	    _extends({}, formControlProps, { className: formControlClasses }),
	    labelText !== undefined ? _react2.default.createElement(
	      _InputLabel2.default,
	      _extends({
	        className: classes.labelRoot + ' ' + labelClasses,
	        htmlFor: id
	      }, labelProps),
	      labelText
	    ) : null,
	    _react2.default.createElement(_Input2.default, _extends({
	      classes: {
	        input: inputClasses,
	        root: marginTop,
	        disabled: classes.disabled,
	        underline: underlineClasses
	      },
	      id: id
	    }, inputProps)),
	    error ? _react2.default.createElement(_Clear2.default, { className: classes.feedback + ' ' + classes.labelRootError }) : success ? _react2.default.createElement(_Check2.default, { className: classes.feedback + ' ' + classes.labelRootSuccess }) : null
	  );
	}
	
	CustomInput.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  labelText: _propTypes2.default.node,
	  labelProps: _propTypes2.default.object,
	  id: _propTypes2.default.string,
	  inputProps: _propTypes2.default.object,
	  formControlProps: _propTypes2.default.object,
	  inputRootCustomClasses: _propTypes2.default.string,
	  error: _propTypes2.default.bool,
	  success: _propTypes2.default.bool,
	  white: _propTypes2.default.bool
	};
	
	exports.default = (0, _withStyles2.default)(_customInputStyle2.default)(CustomInput);
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CloudDownload = __webpack_require__(257);
	
	var _CloudDownload2 = _interopRequireDefault(_CloudDownload);
	
	var _Done = __webpack_require__(138);
	
	var _Done2 = _interopRequireDefault(_Done);
	
	var _withStyles = __webpack_require__(4);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(74);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _GridContainer = __webpack_require__(48);
	
	var _GridContainer2 = _interopRequireDefault(_GridContainer);
	
	var _GridItem = __webpack_require__(40);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _Button = __webpack_require__(25);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CustomInput = __webpack_require__(85);
	
	var _CustomInput2 = _interopRequireDefault(_CustomInput);
	
	var _InfoArea = __webpack_require__(144);
	
	var _InfoArea2 = _interopRequireDefault(_InfoArea);
	
	var _bitnational_whitepaper = __webpack_require__(590);
	
	var _bitnational_whitepaper2 = _interopRequireDefault(_bitnational_whitepaper);
	
	var _footerStyle = __webpack_require__(99);
	
	var _footerStyle2 = _interopRequireDefault(_footerStyle);
	
	var _gatsbyLink = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// @material-ui/icons
	
	//core components
	
	
	var WhitePaper = function (_Component) {
	  _inherits(WhitePaper, _Component);
	
	  function WhitePaper() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WhitePaper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      email: '',
	      emailLoading: false,
	      signupSuccess: false,
	      validationError: ''
	    }, _this.handleChange = function (e) {
	      _this.setState({ email: e.target.value });
	    }, _this.handleSubmit = function (e) {
	      if (typeof window !== 'undefined') {
	        e.preventDefault();
	        var email = _this.state.email;
	
	        if (!email || !email.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g)) {
	          _this.setState({ validationError: 'Please enter an email' });
	          return false;
	        }
	
	        var data = { Data: { Email: email, EmailPerm: '1' } };
	
	        try {
	          _this.setState({ emailLoading: true });
	          fetch('https://clientapi.benchmarkemail.com/Contact/15915579/ContactDetails', {
	            method: 'POST',
	            headers: {
	              'Content-Type': 'application/json; charset=utf-8',
	              AuthToken: '2298B27F-02E9-4144-8548-95C32C169675'
	            },
	            body: JSON.stringify(data)
	          }).then(function (response) {
	            return response.json();
	          }).catch(function (error) {
	            console.error({ Error: error });
	            return false;
	          }).then(function (response) {
	            _this.setState({
	              emailLoading: false,
	              email: '',
	              signupSuccess: true
	            });
	            (0, _gatsbyLink.navigateTo)(_bitnational_whitepaper2.default);
	          });
	        } catch (error) {
	          console.error(error);
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  WhitePaper.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      !this.state.signupSuccess ? _react2.default.createElement(
	        'form',
	        {
	          style: { opacity: this.state.emailLoading ? 0.5 : 1 },
	          onSubmit: this.handleSubmit
	        },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, alignItems: 'center' },
	          _react2.default.createElement(
	            _GridItem2.default,
	            { xs: 9, md: 10 },
	            _react2.default.createElement(_CustomInput2.default, {
	              autoComplete: 'email',
	              inputProps: {
	                onChange: this.handleChange,
	                value: this.state.email
	              },
	              white: this.props.white,
	              error: this.state.validationError.length,
	              id: 'contactemail',
	              labelText: this.state.validationError ? this.state.validationError : 'Your Email...',
	              formControlProps: {
	                fullWidth: true
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _GridItem2.default,
	            { xs: 1, md: 2 },
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.handleSubmit, justIcon: true },
	              _react2.default.createElement(_CloudDownload2.default, null)
	            )
	          )
	        )
	      ) : _react2.default.createElement(_InfoArea2.default, {
	        title: 'Success',
	        description: 'You\'ve been added to the email list',
	        icon: _Done2.default,
	        iconColor: 'success'
	      })
	    );
	  };
	
	  return WhitePaper;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(_footerStyle2.default)(WhitePaper);
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(4);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Icon = __webpack_require__(126);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _infoStyle = __webpack_require__(140);
	
	var _infoStyle2 = _interopRequireDefault(_infoStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	// nodejs library to set properties for components
	
	// nodejs library that concatenates classes
	
	// @material-ui/core components
	
	
	function InfoArea(_ref) {
	  var _classNames, _classNames2, _classNames3;
	
	  var props = _objectWithoutProperties(_ref, []);
	
	  var classes = props.classes,
	      title = props.title,
	      description = props.description,
	      iconColor = props.iconColor,
	      vertical = props.vertical,
	      className = props.className;
	
	  var iconWrapper = (0, _classnames2.default)((_classNames = {}, _classNames[classes.iconWrapper] = true, _classNames[classes[iconColor]] = true, _classNames[classes.iconWrapperVertical] = vertical, _classNames));
	  var iconClasses = (0, _classnames2.default)((_classNames2 = {}, _classNames2[classes.icon] = true, _classNames2[classes.iconVertical] = vertical, _classNames2));
	  var infoAreaClasses = (0, _classnames2.default)((_classNames3 = {}, _classNames3[classes.infoArea] = true, _classNames3[className] = className !== undefined, _classNames3));
	  var icon = null;
	  switch (typeof props.icon) {
	    case 'string':
	      icon = _react2.default.createElement(
	        _Icon2.default,
	        { className: iconClasses },
	        props.icon
	      );
	      break;
	    default:
	      icon = _react2.default.createElement(props.icon, { className: iconClasses });
	      break;
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: infoAreaClasses },
	    _react2.default.createElement(
	      'div',
	      { className: iconWrapper },
	      icon
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.descriptionWrapper },
	      _react2.default.createElement(
	        'h4',
	        { className: classes.title },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.description },
	        description
	      )
	    )
	  );
	}
	
	InfoArea.defaultProps = {
	  iconColor: 'gray'
	};
	
	InfoArea.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.node.isRequired,
	  iconColor: _propTypes2.default.oneOf(['primary', 'warning', 'danger', 'success', 'info', 'rose', 'gray']),
	  vertical: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _withStyles2.default)(_infoStyle2.default)(InfoArea);
	module.exports = exports['default'];

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.WhoWeAreQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-weight: bold;\n'], ['\n  color: ', ';\n  font-weight: bold;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: ', ' ', ';\n\n  @media screen and (max-width: 768px) {\n    padding: 100px ', ';\n  }\n'], ['\n  padding: ', ' ', ';\n\n  @media screen and (max-width: 768px) {\n    padding: 100px ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: ', ' ', ';\n  display: grid;\n  grid-template-columns: 5fr 10fr;\n  grid-gap: ', ' ', ';\n\n  @media screen and (max-width: 768px) {\n    grid-template-columns: 1fr;\n    padding: 50px 0;\n  }\n'], ['\n  padding: ', ' ', ';\n  display: grid;\n  grid-template-columns: 5fr 10fr;\n  grid-gap: ', ' ', ';\n\n  @media screen and (max-width: 768px) {\n    grid-template-columns: 1fr;\n    padding: 50px 0;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding-bottom: 0;\n  display: block;\n  margin: 0 auto;\n  text-align: center;\n\n  > div:last-child {\n    @media screen and (max-width: 1200px) {\n      position: relative;\n      padding-bottom: 56.25%;\n      padding-top: 30px;\n      height: 0;\n      overflow: hidden;\n    }\n\n    iframe {\n      @media screen and (min-width: 1200px) {\n        width: 800px;\n        height: 450px;\n      }\n      @media screen and (max-width: 1200px) {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n  @media screen and (max-width: 768px) {\n    > div {\n      box-sizing: border-box;\n    }\n  }\n'], ['\n  padding-bottom: 0;\n  display: block;\n  margin: 0 auto;\n  text-align: center;\n\n  > div:last-child {\n    @media screen and (max-width: 1200px) {\n      position: relative;\n      padding-bottom: 56.25%;\n      padding-top: 30px;\n      height: 0;\n      overflow: hidden;\n    }\n\n    iframe {\n      @media screen and (min-width: 1200px) {\n        width: 800px;\n        height: 450px;\n      }\n      @media screen and (max-width: 1200px) {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n  @media screen and (max-width: 768px) {\n    > div {\n      box-sizing: border-box;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(20);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(44);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _LayoutContainer = __webpack_require__(65);
	
	var _LayoutContainer2 = _interopRequireDefault(_LayoutContainer);
	
	var _youtubeEmbedVideo = __webpack_require__(948);
	
	var _youtubeEmbedVideo2 = _interopRequireDefault(_youtubeEmbedVideo);
	
	var _Button = __webpack_require__(25);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dialog = __webpack_require__(116);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogTitle = __webpack_require__(120);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _DialogContent = __webpack_require__(118);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Slide = __webpack_require__(84);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _withStyles = __webpack_require__(4);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _CustomInput = __webpack_require__(85);
	
	var _CustomInput2 = _interopRequireDefault(_CustomInput);
	
	var _CloudDownload = __webpack_require__(257);
	
	var _CloudDownload2 = _interopRequireDefault(_CloudDownload);
	
	var _kebabCase = __webpack_require__(805);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _Grid = __webpack_require__(74);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _GridItem = __webpack_require__(40);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _modalStyle = __webpack_require__(141);
	
	var _modalStyle2 = _interopRequireDefault(_modalStyle);
	
	var _Whitepaper = __webpack_require__(457);
	
	var _Whitepaper2 = _interopRequireDefault(_Whitepaper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function Transition(props) {
	  return _react2.default.createElement(_Slide2.default, _extends({ direction: 'down' }, props));
	}
	
	var WhoWeArePage = function (_Component) {
	  _inherits(WhoWeArePage, _Component);
	
	  function WhoWeArePage() {
	    _classCallCheck(this, WhoWeArePage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      whitepaperModal: false,
	      windowWidth: 1920
	    };
	    return _this;
	  }
	
	  WhoWeArePage.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ windowWidth: window.innerWidth });
	  };
	
	  WhoWeArePage.prototype.render = function render() {
	    var _this2 = this;
	
	    var pageEdges = this.props.data.page.edges[0];
	    var pageData = pageEdges.node.frontmatter;
	    var classes = this.props.classes;
	
	    return _react2.default.createElement(
	      _LayoutContainer2.default,
	      null,
	      _react2.default.createElement(
	        WWAContainer,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: pageData.title }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            pageData.title
	          ),
	          _react2.default.createElement(
	            'h4',
	            { style: { color: 'black' } },
	            _react2.default.createElement(
	              'strong',
	              null,
	              pageData.subtitle
	            )
	          )
	        ),
	        pageData.section.map(function (section, i) {
	          return _react2.default.createElement(
	            SectionContainer,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                { id: (0, _kebabCase2.default)(section.title), style: { marginTop: 0 } },
	                section.title
	              ),
	              i === 0 && _react2.default.createElement(
	                _Button2.default,
	                {
	                  onClick: function onClick() {
	                    return _this2.setState({ whitepaperModal: true });
	                  },
	                  round: true,
	                  color: 'info'
	                },
	                _react2.default.createElement(
	                  ButtonText,
	                  null,
	                  'Whitepaper'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                section.body
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(
	          VideoContainer,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              pageData.video.body
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_youtubeEmbedVideo2.default, {
	              suggestions: false,
	              showInfo: false,
	              videoId: pageData.video.id,
	              width: this.state.windowWidth <= 768 ? 250 : 500,
	              height: this.state.windowWidth <= 768 ? 140.625 : 281.25
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Dialog2.default,
	        {
	          classes: {
	            root: classes.modalRoot,
	            paper: classes.modal
	          },
	          TransitionComponent: Transition,
	          onClose: function onClose() {
	            return _this2.setState({ whitepaperModal: false });
	          },
	          open: this.state.whitepaperModal
	        },
	        _react2.default.createElement(
	          _DialogTitle2.default,
	          { className: classes.modalHeader },
	          'Download Whitepaper'
	        ),
	        _react2.default.createElement(
	          _DialogContent2.default,
	          { className: classes.modalBody },
	          _react2.default.createElement(_Whitepaper2.default, null)
	        )
	      )
	    );
	  };
	
	  return WhoWeArePage;
	}(_react.Component);
	
	var ButtonText = _styledComponents2.default.span(_templateObject, function (p) {
	  return p.theme.colors.blue;
	});
	
	var WWAContainer = _styledComponents2.default.div(_templateObject2, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col(2);
	}, function (p) {
	  return p.theme.col(2);
	});
	
	var SectionContainer = _styledComponents2.default.div(_templateObject3, function (p) {
	  return p.theme.col();
	}, function (p) {
	  return p.theme.col(2);
	}, function (p) {
	  return p.theme.col(0.5);
	}, function (p) {
	  return p.theme.col();
	});
	
	var VideoContainer = (0, _styledComponents2.default)(SectionContainer)(_templateObject4);
	
	var WhoWeAreQuery = exports.WhoWeAreQuery = '** extracted graphql fragment **';
	
	exports.default = (0, _withStyles2.default)(_modalStyle2.default)(WhoWeArePage);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-whoweare-jsx-20d00e3ef26a487f6aec.js